module.exports = __webpack_public_path__ + "img/cafeteria.a091517d.svg";